export default "__VITE_ASSET__Bd0xN5fu__"